import {inject, IReactComponent} from 'mobx-react';
import {HistoryConsoleFilter} from './HistoryConsoleFilter';

const mapStoresToProps = (stores: Record<string, any>) => ({
    ctrl: stores.inviteStore?.historyConsoleFilterController
});

const HistoryConsoleFilterComponent = inject(mapStoresToProps)(HistoryConsoleFilter) as IReactComponent;

export default HistoryConsoleFilterComponent;
